/**
 * Local Wikipedia-style lore article: The Sentients (faction).
 * Placeholder until full article text is authored.
 */
import { createComingSoonArticle } from './createComingSoonArticle';

const theSentientsArticle = createComingSoonArticle({
  title: 'The Sentients',
  image: '/factions/sentients.png',
});

export default theSentientsArticle;
